import PreRenderUrls from "../../prerender-urls.json";

const lookupByUrl = (url) => {
  for (const entry of PreRenderUrls) {
    if (entry.url === url) {
      return entry;
    }
  }
  return undefined;
};

export { lookupByUrl };
